export const experienceData = [
  {
    id: 1,
    title: 'TARE Project Intern',
    company: 'ANRF (SERB) - Department of Science & Technology, Govt. of India',
    location: 'India',
    duration: 'May 2025 - Aug 2025',
    type: 'Internship',
    description: 'Worked on a real-time vehicle tracking and traffic density estimation system using Computer Vision and AI technologies. Focused on vehicle detection, tracking, and backend API integration for processing aerial footage.',
    responsibilities: [
      'Developed a real-time vehicle tracking system using YOLOv8 and OpenCV',
      'Processed aerial drone footage for vehicle detection and monitoring',
      'Built backend APIs using FastAPI for data processing and integration',
      'Implemented traffic density estimation techniques using tracked vehicle data',
      'Optimized detection pipelines for improved real-time performance',
      'Collaborated on research-driven AI solutions for intelligent transportation systems'
    ],
    technologies: ['Python', 'YOLOv8', 'OpenCV', 'FastAPI', 'Computer Vision'],
    achievements: [
      'Successfully developed a real-time AI-powered vehicle tracking system',
      'Applied advanced computer vision techniques for traffic monitoring',
      'Secured 3rd Place recognition through the TARE Project initiative'
    ]
  },

  {
    id: 2,
    title: 'Technical Team Member',
    company: 'IEEE SRMIST',
    location: 'Chennai, India',
    duration: 'Nov 2024 - Present',
    type: 'Leadership & Technical',
    description: 'Contributing to web development initiatives and technical infrastructure for IEEE SRMIST while supporting large-scale technical events and student communities.',
    responsibilities: [
      'Contribute to web development and technical projects for IEEE SRMIST',
      'Support technical infrastructure and event management activities',
      'Collaborate with team members to improve digital platforms',
      'Assist in organizing and executing technical workshops and events',
      'Provide technical support for student-focused initiatives',
      'Work with cross-functional teams to enhance community engagement'
    ],
    technologies: ['JavaScript', 'React', 'Node.js', 'Git', 'GitHub'],
    achievements: [
      'Supported technical initiatives impacting 800+ students',
      'Contributed to successful execution of technical events and workshops',
      'Actively participated in strengthening IEEE SRMIST digital presence'
    ]
  }
];


export const educationData = [
  {
    id: 1,
    degree: 'Bachelor of Technology in Computer Science and Engineering',
    institution: 'SRM Institute of Science and Technology',
    location: 'Chennai, Tamil Nadu, India',
    duration: '2023 - 2027',
    gpa: '9.65 / 10',
  },

  {
    id: 2,
    degree: 'Higher Secondary Education (Class XII)',
    institution: 'Saraswati Vidya Mandir Inter College',
    location: 'India',
    duration: '2022 - 2023',
    gpa: '86.4%',
  },

  {
    id: 3,
    degree: 'Secondary Education (Class X)',
    institution: 'Saraswati Vidya Mandir Inter College',
    location: 'India',
    duration: '2020 - 2021',
    gpa: '82.83%',
  }
];


export const certificationsData = [
  {
    id: 1,
    name: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services (AWS)',
    date: 'March 14, 2026',
  },
  {
    id: 2,
    name: 'Data Base Management System',
    issuer: 'NPTEL',
    date: 'Mar 2025',
  },
  {
    id: 3,
    name: 'Awarded by SRM Institute of Science and Technology for academic excellence',
    issuer: 'SRM Institute of Science and Technology',
    date: '2025'
  },
  {
    id: 4,
    name: 'Amazon AWS Cloud Virtual Internship',
    issuer: 'Amazon Web Services (AWS)',
    date: '2025'
  },
  {
    id: 5,
    name: 'Smart India Hackathon (SIH) Participation',
    issuer: 'Smart India Hackathon',
    date: '2025'
  },
  {
    id: 6,
    name: 'Certificate of Merit – SRMIST Science & IoT Exhibition',
    issuer: 'SRM Institute of Science and Technology',
    date: '2025'
  }
];
